<template>
  <v-dialog v-model="dialog" max-width="900px" @click:outside="_onNo">
    <v-card title="Are you sure?" class="mb-0">
      <v-card-title class="ma-2 text-center d-block">
        <span>Please choose destination folder</span>
      </v-card-title>
      <v-divider class="ma-2"></v-divider>
      <v-card-text>
        <share-treeview :bucket="this.bucket" :parentItem="this.id"/>
      </v-card-text>
      <v-card-actions class="ma-2 text-center">
        <v-spacer></v-spacer>
        <v-btn
          color="white"
          name="Cancel"
          class="text-right mr-10"
          @click="_onNo()"
          >NO</v-btn
        >
        <v-btn color="primary" name="Add" class="text-right ml-10" @click="_onYes()"
          >YES</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import ShareTreeview from '@/components/layout/ShareTreeview.vue';
import awsmobile from "@/api/aws-exports";

export default {
  props: {
    id: {
      type: Object,
      default: null,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    bucket: {
      type: String,
      default: awsmobile["provider_bucket"],
    }
  },
  components: {
    ShareTreeview
  },
  methods: {
    _onYes() {
      this.$emit("deliver");
      this.$emit("update:dialog", false);
    },
    async _onNo() {
      this.$emit("close_md_dialog")
      this.$emit("update:dialog", false);
    }
  },
};
</script>
<style scoped>
</style>
